<div mat-dialog-content>
  <div class="mat-dialog-content">
    <form class="form" [formGroup]="model" (ngSubmit)="submit()">
      <div class="row">
        <div class="col-md-6">
          <div class="head-profile-modal-list">
            <h2>Procedimento: </h2>
          </div>
          <div class="body-confirm-modal-list">
            <div class="row">
              <div class="col-md-12">
                <label>Nome procedimento: </label>
                <p>{{procedure.procedureName}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>Observação: </label>
                <p>{{procedure.observation}}</p>
              </div>
            </div>
            @if (this.useScheduling) {
              <div class="check-estimative-details">
                <div class="col-12">
                  <span class="name-detail">Data e hora da checagem: </span>
                  <span>Data: {{this.medicalProcedureCheck.datetimeCheckEstimative | date:'dd/MM/yyyy'}}</span>
                  <span>Hora: {{this.medicalProcedureCheck.datetimeCheckEstimative | date:'HH:mm'}}</span>
                </div>
                @if (this.medicalProcedureCheck.schedulingObservation) {
                  <div>
                    <span class="name-detail">Observação do aprazamento: </span>
                    <span>{{this.medicalProcedureCheck.schedulingObservation}}</span>
                  </div>
                }
              </div>
            }
            @if (data.actions && procedure.idProcedureStatus != closedStatus) {
              <div class="row">
                <div class="col-12">
                  <button mat-flat-button type="button" color="primary" class="btn-block"
                  (click)="openPatientBarCodeModal()">Ler paciente</button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1">
                  <mat-checkbox matInput formControlName="checkName"></mat-checkbox>
                </div>
                <div class="col-md-11">
                  <label>Nome paciente e Data de nascimento: </label>
                  <p>{{this.data.patientName}}, {{this.data.birthDate | date:'dd/MM/yyyy'}}</p>
                </div>
                <div class="col-md-1">
                  <mat-checkbox matInput formControlName="checkProcedure"></mat-checkbox>
                </div>
                <div class="col-11">
                  <label>Nome do procedimento: </label>
                  <p>{{procedure.procedureName}}</p>
                </div>
              </div>
            }
          </div>
        </div>
        @if (procedure.listMedicalProcedureCheck) {
          <div class="col-md-6">
            <div class="head-profile-modal-list">
              <h2>Histórico do Procedimento: </h2>
            </div>
            @for (item of procedure.listMedicalProcedureCheck; track item) {
              <div class="row">
                <div class="col-md-12">
                  @if (item.datetimeCheckFulfilled) {
                    <label>
                      Checado
                    </label>
                  }
                  <p>{{item.datetimeCheckFulfilled | date:'dd/MM/yyyy HH:mm'}}</p>
                  <p>{{item.professionName}} - {{item.userName}}</p>
                </div>
              </div>
            }
          </div>
        }
        <div class="footer-modal-list">
          @if (!isReadonly && data.actions) {
            <button mat-flat-button color="primary" class="btn-block" type="submit">
              @if (isLoading == false) {
                <span>Concluir</span>
              }
              @if (isLoading == true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
              }
            </button>
          }
          @if (!isReadonly && data.actions && this.canSuspend) {
            <button mat-flat-button color="accent" class="btn-block" type="button" (click)="suspendPrescriptionModal()">
              @if (isLoading == false) {
                <span>Suspender horário</span>
              }
              @if (isLoading == true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
              }
            </button>
          }
          <button mat-flat-button type="button" color="primary" class="btn-block" (click)="close()">
            @if (isLoading == false) {
              <span>Fechar</span>
            }
            @if (isLoading == true) {
              <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
            }
          </button>
        </div>
      </div>
    </form>
  </div>
</div>